import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./FullSpanMenuModal.css";
import BackArrow from "../icons/iconComponents/BackArrow";
import { updateLocalSetting } from "../Environment";
import { useTheme } from "../contexts/ThemeContext";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";

// import SvgNoteIcon from "../icons/iconComponents/NoteIcon";
// import SvgAddIcon from "../icons/iconComponents/AddIcon";
// import SvgNewFolderIcon from "../icons/iconComponents/NewFolderIcon";
// import SvgStarIcon from "../icons/iconComponents/StarIcon";
import TreeContainer from "./TreeContainer";
import { InputModalComponent } from "./Modal";
// import AllNotesIcon from "../icons/AllNotesIcon.svg";

import {
    Add32,
    Notebook32,
    FolderAdd32,
    Favorite32,
    Edit32,
} from "@carbon/icons-react";

function FullSpanMenuModal(props) {
    const [isActivated, setIsActivated] = useState(props.isModalActive);
    const theme = useTheme();

    const navigate = useNavigate();
    const { isNoteViewActivated, isNewFolderView } = props.settings;
    const settings = props.settings;
    const user = props.user;
    const { isPremium } = props.user;

    function onBackClick(e) {
        e.preventDefault();
        updateLocalSetting("isFullScreenMenuActivated", false);
        updateLocalSetting("isNewFolderView", false);
    }

    function onAddSourceClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isNewFolderView");
            // record.setValue("Q2F0ZWdvcnlOb2RlOjkzMDE=", "categoryId");
        });
        navigate("/add-source");
    }

    function onCreateFeedClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isNewFolderView");
        });
    }

    function onAllArticlesClick(e) {
        e.preventDefault();
        let metaSourceName = "All Subscriptions";
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "allSubscriptions");

            record.setValue(metaSourceName, "metaSourceName");
            record.setValue("Articles from ", "metaDescription");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");

            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
        });

        updateLocalSetting("isFullScreenMenuActivated", false);
    }

    function onBookmarkClick(e) {
        e.preventDefault();
        updateLocalSetting("isFullScreenMenuActivated", false);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isBookmarkView");
            record.setValue("Bookmarked Posts", "metaDescription");
            record.setValue("", "metaSourceName");
            record.setValue(false, "isPostNoteView");

            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue(false, "allSubscriptions");

            navigate("/home");
        });
    }

    let isOpen = isActivated ? "open" : "close";
    let isHidden = isActivated ? "" : "inactive";

    function onChange(e) {
        e.preventDefault();
    }

    function onNoteViewClick(e) {
        e.preventDefault();

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isPostNoteView");
            record.setValue(false, "isBookmarkView");
            record.setValue("Posts with Notes", "metaDescription");
            record.setValue("", "metaSourceName");

            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue(false, "allSubscriptions");
        });

        updateLocalSetting("isFullScreenMenuActivated", false);

        navigate("/home");
    }

    function onManageClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAccountView");
            record.setValue(true, "isSubListView");
            record.setValue(false, "isProfileView");
            navigate("/settings");
        });
    }

    return (
        <>
            {isNewFolderView ? (
                <div
                    className={`fullspan-modal-container theme-${theme.light}`}
                >
                    <div className={`theme-${theme.light} fullspan-wrapper`}>
                        <div
                            className={`fullspan-modal-header theme-${theme.light}`}
                        >
                            <div
                                className={`theme-${theme.light} theme-${
                                    theme.border + "-true"
                                } fullspan-header-room theme-${theme.light}`}
                            >
                                <BackArrow
                                    className={`detailview-backarrow detailview-header-icon`}
                                    onClick={onBackClick}
                                />

                                <div className="fullspan-header-icons"></div>
                                <div></div>
                            </div>
                        </div>
                        <div className={`fullspan-modal-content`}>
                            <div className={`fullspan-modal-content-matter`}>
                                {isNewFolderView ? (
                                    <div
                                        className={`fullspan-input-modal-component`}
                                    >
                                        <InputModalComponent />
                                    </div>
                                ) : (
                                    <div className="menu-structure">
                                        <div
                                            className={`all-articles theme-${theme.paragraph}`}
                                            onClick={onAllArticlesClick}
                                        >
                                            All Subscriptions
                                        </div>
                                        <TreeContainer settings={settings} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className={`fullspan-modal-container theme-${theme.light}`}
                >
                    <div className={`theme-${theme.light} fullspan-wrapper`}>
                        <div
                            className={`fullspan-modal-header theme-${theme.light}`}
                        >
                            <div
                                className={`theme-${theme.light} theme-${
                                    theme.border + "-true"
                                } fullspan-header-room theme-${theme.light}`}
                            >
                                <BackArrow
                                    className={`detailview-backarrow detailview-header-icon`}
                                    onClick={onBackClick}
                                />

                                <div className="fullspan-header-icons">
                                    <div className="icon-box">
                                        <Add32
                                            onClick={onAddSourceClick}
                                            className="carbon-icon"
                                            aria-label="Add"
                                        />
                                        <label>Add Feed</label>
                                    </div>

                                    <div className="icon-box">
                                        <Edit32 onClick={onManageClick} />
                                        <label>Manage</label>
                                    </div>
                                    {/* <div className="icon-box"> */}
                                    {/*     <FolderAdd32 */}
                                    {/*         onClick={onCreateFeedClick} */}
                                    {/*         className="carbon-icon" */}
                                    {/*         aria-label="Notes" */}
                                    {/*     /> */}
                                    {/*     <label>Add Folder</label> */}
                                    {/* </div> */}
                                    <div className="icon-box">
                                        <Notebook32
                                            onClick={onNoteViewClick}
                                            className="carbon-icon"
                                            aria-label="Notes"
                                        />
                                        <label>Notes</label>
                                    </div>
                                    <div className="icon-box">
                                        <Favorite32
                                            onClick={onBookmarkClick}
                                            className="carbon-icon"
                                            aria-label="Notes"
                                        />
                                        <label>Bookmarks</label>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                        </div>
                        <div className={`fullspan-modal-content`}>
                            <div className={`fullspan-modal-content-matter`}>
                                <div className="menu-structure">
                                    <div
                                        className={`all-articles theme-${theme.paragraph}`}
                                        onClick={onAllArticlesClick}
                                    >
                                        All Subscriptions
                                    </div>
                                    <TreeContainer settings={settings} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default FullSpanMenuModal;
